export const environment = {
  production: false,
  baseUrl: 'https://api.dev.pave.com.my/',
  GA_ID: 'G-EKXC3DMMJK',
  Ideal_Timeout: 1800,
  siteKey: '6Le4iGopAAAAAAS6LZt7vqdq9BFzbjB0Ir-zbv0A',
  dev: false,
  MAINTANCE_CHECK_DELAY: 300000,
  GOOGLE_MAPS_API_KEY: 'AIzaSyCu7NFlm-93pMSnysfeIkPsvkhhOVWrsBk',
  CHATBOT_URL: 'https://d3tkp103ku818j.cloudfront.net/',
  SECRET_KEY: 'e4b7c6a8d93f46c28bfe3489fa5630d7',
  toastrTimeout: 5000,
  toastrTimeoutDup: 15000,
  CHATBOT_AVATAR: 'https://images.dev.pave.com.my/iDAMerdeka.png',
  INSURANCE_PRODUCT_ID: 'INS00011',
  imageBaseUrl: 'https://images.dev.pave.com.my/',
};
